import type { TiktokLyricsPlatform } from 'src/Types/campaigns'

import { AppStore } from '.'

export type AppDispatch = AppStore['store']['dispatch']

export enum NameSpace {
  Theme = 'THEME',
  Genres = 'GENRES',
  CampaignList = 'CAMPAIGN_LIST',
  SpotifyToken = 'SPOTIFY_TOKEN',
  Track = 'TRACK',
  Sidebar = 'SIDEBAR',
  Video = 'VIDEO',
  Playlists = 'PLAYLISTS',
  Transactions = 'TRANSACTIONS',
  Artists = 'ARTISTS',
  Reviews = 'REVIEWS',
  Influencer = 'INFLUENCER',
  Wise = 'WISE',
  Campaign = 'CAMPAIGN',
  SpotifyTracks = 'SPOTIFY_TRACKS',
  ArtistPassword = 'ARTIST_PASSWORD',
  TikTokTrack = 'TIKTOK_TRACK',
  Notifications = 'NOTIFICATIONS',
  ArtistDeleteAccount = 'ARTIST_DELETE_ACCOUNT',
  CuratorDeleteAccount = 'CURATOR_DELETE_ACCOUNT',
  SessionNotifications = 'SESSION_NOTIFICATIONS',
  GoogleAnalytics = 'GOOGLE_ANALYTICS',
  GA4 = 'GA4',
  AuthType = 'AUTH_TYPE',
  Credentials = 'CREDENTIALS',
  User = 'USER',
  EmailPassword = 'EMAIL_PASSWORD',
  AudienceTiktok = 'AUDIENCE_TIKTOK',
  Cupon = 'CUPON',
  TiktokCampaign = 'TIKTOK_CAMPAIGN',
  Alert = 'ALERT',
  CuratorBalanceHistory = 'CURATOR_BALANCE_HISTORY',
  Payment = 'PAYMENT',
  PayPalTransactions = 'PAYPAL_TRANSACTIONS',
  SourceBusterEvent = 'SOURCE_BUSTERS_EVENT',
  ReferAndEarn = 'REFER_AND_EARN',
  Analytics = 'ANALYTICS',
  CURATOR_LEVELS = 'CURATOR_LEVELS',
  GET_PREMIUM = 'GET_PREMIUM',
  REFERRAL_HASH = 'REFERRAL_HASH',
  SEARCH_PLAYLIST = 'SEARCH_PLAYLIST',
  COUNTRY = 'COUNTRY',
  CRETOR_REGISTER = 'CRETOR_REGISTER',
  TYPEFORM = 'TYPEFORM',
  CHECKOUT_TIMER = 'CHECKOUT_TIMER',
  PageLayout = 'PAGE_LAYOUT',
  CANCELED_CREATOR_ALERTS = 'CANCELED_CREATOR_ALERTS',
  SPOTIFY_CAMPAIGN_MATCHING = 'SPOTIFY_CAMPAIGN_MATCHING',
}

export enum ErrorCode {
  Bed_Request = 400,
  Unauthorized = 401,
  Forbidden = 403,
  NotFound = 404,
  InternalServerError = 500,
  ServiceUnavailable = 503,
  GatewayTimeout = 504,
  Conflict = 409,
}

export enum SUCCESS_CODE {
  OK = 200,
  NO_CONTENT = 204,
}

export interface ApiError {
  message: string
  code: number
  payload?: Record<string, number | string>
}

export enum SliceStatus {
  Idle = 'idle',
  Loading = 'loading',
  Succeeded = 'succeeded',
  Failed = 'failed',
}

export interface SliceState {
  status: SliceStatus
  error: ApiError | null
}

export interface Sound {
  trackAuthorName: string
  trackCoverUrl: string
  trackTitle: string
  trackTiktokUrl: string
  id: number
  commentType: string
  lyricsLink?: string | null
  lyricsPlatform?: TiktokLyricsPlatform | null
}
